import React, { useState } from 'react';
import { Tabs, TabPanel } from 'react-tabs';
import Typography from '@mui/material/Typography';


const ProfileForm = ({ userData, openConnectModal }) => {

    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
 
    const containerStyle = {
        marginTop: 0,
        padding: '0 15px',
        width: '100%',
        maxWidth: window.innerWidth < 768 ? '100%' : 900,
        minWidth: window.innerWidth < 768 ? '100%' : 900,
    };

    const tableCell = {
        fontSize: "14px"
    }

    return (
        <>
            <div className="main details" style={{ marginTop: 0 }}>
                <section className="user-profile flat-tabs" style={{ padding: 0 }}>
                    <div className="container" style={{ padding: 0 }}>
                        <div className="row"  >
                            <Tabs style={{ padding: 0 }}>
                                <TabPanel   >
                                    <div className="content-inner profile" style={containerStyle}>
                                        <form action="#"  >
                                            <Typography color="inherit" variant='h5'  style={{color: "#119f24"}}>Account Overview</Typography>
                                            <div className="bt d-flex" style={{ marginBottom: 10, marginTop: 40 }}>
                                                <div className="left">
                                                    <h6 style={{color: "#119f24"}}>STAKE</h6>
                                                    <ul>
                                                        <li>
                                                            <p>Staked Amount</p>
                                                            <p className="text" style={{color: "#119f24"}}>{userData ? userData.stakedAmount : 0} OSCAR</p>
                                                        </li>
                                                        <li>
                                                            <p>Available Rewards</p>
                                                            <p className="text" style={{color: "#119f24"}}>{userData ? userData.pendingReward : 0} OSCAR</p>
                                                        </li>
                                                        <li>
                                                            <p>Total Claimed</p>
                                                            <p className="text" style={{color: "#119f24"}}>{userData ? userData.totalRewardClaimed : 0} OSCAR</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="right">
                                                    <h6 style={{color: "#119f24"}}>REFERRAL</h6>
                                                    <ul>
                                                        {/* <li>
                                                        <p>Referral Link</p>
                                                        <p className="text">{userData ? userData.referralLink : "No referral link available."}

                                                        </p>
                                                    </li> */}
                                                        <li>
                                                            <p>Referred Friends</p>
                                                            <p className="text" style={{color: "#119f24"}}>{userData ? userData.bonusCount : 0} </p>
                                                        </li>
                                                        <li>
                                                            <p>Available Bonus</p>
                                                            <p className="text" style={{color: "#119f24"}}>{userData ? userData.bonusDebt : 0} OSCAR</p>
                                                        </li>
                                                        <li>
                                                            <p>Total Claimed</p>
                                                            <p className="text" style={{color: "#119f24"}}>{userData ? userData.totalBonusClaimed : 0} OSCAR</p>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>

                                            {!userData && (
                                                <button type="submit" className="btn-action" onClick={openConnectModal}>
                                                    CONNECT WALLET
                                                </button>
                                            )}
                                        </form>
                                    </div>

                                </TabPanel>
                            </Tabs>

                        </div>
                    </div>
                </section>


                <section className="coin-list">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="block-text">
                                </div>

                                <div className="coin-list__main">
                                    <div className="flat-tabs">
                                        <ul className="menu-tab">
                                            <li
                                                className={activeTab === 0 ? "active" : ""}
                                                onClick={() => handleTabClick(0)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <h6 className="fs-16">Claim History</h6>
                                            </li>
                                            <li
                                                className={activeTab === 1 ? "active" : ""}
                                                onClick={() => handleTabClick(1)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <h6 className="fs-16">Bonus History</h6>
                                            </li>
                                            <li
                                                className={activeTab === 2 ? "active" : ""}
                                                onClick={() => handleTabClick(2)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <h6 className="fs-16">Referral History</h6>
                                            </li>
                                        </ul>
                                        <div className="content-tab">
                                            <div className="content-inner">
                                                <table className="table" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                    <thead >
                                                        {activeTab === 0 && (
                                                            <tr>
                                                                <th scope="col"></th>
                                                                <th scope="col" style={tableCell}>#</th>
                                                                <th scope="col" style={tableCell}>Staked Amount</th>
                                                                <th scope="col" style={tableCell}>Claimed Amount</th>
                                                                <th scope="col" style={tableCell}>Stake Date</th>
                                                                <th scope="col" style={tableCell}>Claim Date</th>
                                                            </tr>
                                                        )}
                                                        {activeTab === 1 && (
                                                            <tr>
                                                                <th scope="col" style={tableCell}></th>
                                                                <th scope="col" style={tableCell}>#</th>
                                                                <th scope="col" style={tableCell}>Claim Date</th>
                                                                <th scope="col" style={tableCell}>Claimed Amount</th>
                                                            </tr>
                                                        )}
                                                        {activeTab === 2 && (
                                                            <tr>
                                                                <th scope="col"></th>
                                                                <th scope="col" style={tableCell}>#</th>
                                                                <th scope="col" style={tableCell}>Referred Address</th>
                                                                <th scope="col" style={tableCell}>Referred Stake Amount</th>
                                                                <th scope="col" style={tableCell}>Bonus Received</th>
                                                                <th scope="col" style={tableCell}>Date</th>
                                                            </tr>
                                                        )}
                                                    </thead>
                                                    <tbody style={{ fontSize: '14px' }}>
                                                        {activeTab === 0 &&
                                                            userData?.rewardClaimHistory?.map((item, index) => (
                                                                <tr key={index}>
                                                                    <th scope="row" style={tableCell}>
                                                                        <span className="icon-star"></span>
                                                                    </th>
                                                                    <td style={tableCell}>{index + 1}</td>
                                                                    <td style={tableCell}>{item.stakedAmount}</td>
                                                                    <td style={{ ...tableCell }} className="boild">{item.claimedAmount}</td>
                                                                    <td style={tableCell}>{item.timestamp}</td>
                                                                    <td style={tableCell} className="boild">{item.claimTimestamp}</td>
                                                                </tr>
                                                            ))}

                                                        {activeTab === 1 &&
                                                            userData?.bonusClaimHistory?.map((item, index) => (
                                                                <tr key={index}>
                                                                    <th scope="row" style={tableCell}>
                                                                        <span className="icon-star"></span>
                                                                    </th>
                                                                    <td style={tableCell}>{index + 1}</td>
                                                                    <td style={tableCell}>{item.claimedAmount}</td>
                                                                    <td style={tableCell} className="boild">{item.claimTimestamp}</td>
                                                                </tr>
                                                            ))}

                                                        {activeTab === 2 &&
                                                            userData?.bonusHistory?.map((item, index) => (
                                                                <tr key={index}>
                                                                    <th scope="row">
                                                                        <span className="icon-star"></span>
                                                                    </th>
                                                                    <td style={tableCell}>{index + 1}</td>
                                                                    <td style={tableCell}>{item.referrer}</td>
                                                                    <td style={tableCell} className="boild">{item.stakedAmount}</td>
                                                                    <td style={tableCell} className="boild">{item.bonusAmount}</td>
                                                                    <td style={tableCell}>{item.timestamp}</td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ProfileForm;
